var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1280,
    viewBox: "0 0 1920 1280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1023_3316)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.52,
    cy: 668.041,
    rx: 622.518,
    ry: 65.7924,
    transform: "rotate(8.54182 846.52 668.041)",
    fill: "#31D054"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.84283 368.602C165.487 452.288 1294.73 963.368 1920 435.97V1280C1780.2 1104.2 1415.72 800.34 837.484 682.876C302.353 574.169 -275.093 1021.28 -319.292 1116.19V1131.79C-322.953 1129.19 -322.852 1123.83 -319.292 1116.19V0C-272.693 89.7563 -171.173 284.915 -2.84283 368.602Z",
    fill: "url(#paint0_diamond_1023_3316)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1023_3316",
    x: 70.8281,
    y: 394.971,
    width: 1551.38,
    height: 546.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80,
    result: "effect1_foregroundBlur_1023_3316"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_1023_3316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-97 513) rotate(10.0831) scale(2276.16 3986.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.031676,
    stopColor: "#01061B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261549,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729914,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01061B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsBg);
export default __webpack_public_path__ + "static/media/about_us_bg.d9fdd1847cc2f1837ef4963adad36952.svg";
export { ForwardRef as ReactComponent };